import {Injectable} from '@angular/core';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {ArrayResponse, BaseEffect, error, SendBackResult} from '../index';
import {Router} from '@angular/router';
import {LoadTransportersFailAction, LoadTransportersSuccessAction, transportersActionTypes} from '../actions/transporters';
import {Transporter} from '../models/transporter';
import {TransporterService} from '../services/transporter.service';
import {L10nTranslationService} from 'angular-l10n';
import {of} from 'rxjs';
import {ApiCacheService} from '../services/cache.service';

@Injectable()
export class TransportersEffect extends BaseEffect {


  load$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(transportersActionTypes.LOAD),
      debug('Transporters load action received.'),
      switchMap(() => {
        const cacheKey = 'transporters';
        const cached = this.apiCacheService.get<Transporter[]>(cacheKey);

        if (cached) {
          return of(new LoadTransportersSuccessAction(cached));
        }

        return this.transporterService.getTransporters().pipe(
          map((resp: SendBackResult<ArrayResponse<Transporter>>) => {
            const transporters = resp.data.array;
            this.apiCacheService.set(cacheKey, transporters);
            return new LoadTransportersSuccessAction(transporters);
          }),
          catchError(res => this.catchResponseError(res))
        );
      })
    );
  });


  loadFail$ = createEffect(() => { return this.actions$.pipe(ofType(transportersActionTypes.LOAD_FAIL),
    debug('A server error occurred while retrieving Transporters list.'),
    map((action: LoadTransportersFailAction) =>
      error(this.translation.translate('TRANSPORTERS_LOAD_ERROR'), this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  protected handleUnhandledError = (response) => new LoadTransportersFailAction(response['error'].message)

  protected handleGoneError = (response) => {
    return new LoadTransportersFailAction(response['error'].message);
  }

  constructor(router: Router,
              private actions$: Actions,
              private translation: L10nTranslationService,
              private apiCacheService: ApiCacheService,
              private transporterService: TransporterService) {
  super(router);
  }
}
